import React from 'react';

interface Props {
    children?: React.ReactNode;
    className?: string;
}

export default function FormHint({ children, className = '' }: Props) {
    return <span className={`form-hint ${className}`.trim()}>{children}</span>;
}
